export const ssoGQLFields = () => `
  authorizationUrl
  buttonText
  clientId
  clientSecret
  idpUrl
  logoutUrl
  name
  profileSyncTtlSeconds
  provider
  scopes
  settingsUrl
  signUpUrl
  status
  tokenUrl
  type
  userProfileUrl
  defaultRelayState
  allowSignUp
`
